module.exports = __webpack_public_path__ + "privateAssetLabCarousel.5c216bc1112c147d3290a0a7db685a57.png";